import React, { useState } from "react";
import { Space, Tabs, Typography, message } from "antd";
import { useSelector } from "react-redux";

import PreloaderNew from "../UI/PreloaderNew/PreloaderNew";




import DocumentationList from "./DocumentationList";
const { Title, Text } = Typography;
const styleTextGray = { color: "#7A7D86" };

function DocumentationArea() {
	const [messageApi, contextHolder] = message.useMessage();


	message.config({ duration: 5 });


	return (
		<Space direction="vertical" size={20} style={{ width: "100%" }}>
			{contextHolder}
			<Title level={3} style={{ margin: 0 }}>Документация</Title>
			<DocumentationList />
		</Space>
	)
}




export default DocumentationArea;
